import type { Config } from "@jti/fe-common";
import { getConfig, getIsEvo } from "@jti/fe-common";

export { getIsEvo };

// TODO(remove default in DESP-160380): getConfig() default keeps existing callers backward compatible until they pass config.
export const getEvoVersion = (config: Partial<Pick<Config, "EVO_VERSION">> = getConfig()): "v5" | "v6" =>
  config.EVO_VERSION ?? "v5";

export const isEvoV6 = (config: Partial<Pick<Config, "EVO_VERSION">> = getConfig()): boolean =>
  getEvoVersion(config) === "v6";
